<div class="upload-modal">

  <div class="upload-modal__header">
    <div class="upload-modal__icon">
      <mat-icon>upload_file</mat-icon>
    </div>

    <div>
      <h2>Import Data</h2>
      <p>Select a warehouse, file type, and upload your report.</p>
    </div>
  </div>

  <div class="upload-modal__body">

    <div class="upload-modal__fields">

      <mat-form-field
        *ngIf="canSelectWarehouse"
        appearance="outline"
        class="theme-select"
      >
        <mat-label>Warehouse</mat-label>

        <mat-select
          [(ngModel)]="selectedWarehouseId"
          name="selectedWarehouseId"
          (selectionChange)="selectedFile = null; selectedFiles = []"
        >
          <mat-option
            *ngFor="let warehouse of warehouses"
            [value]="warehouse.id"
          >
            {{ warehouse.name || (warehouse.company + ' - ' + warehouse.city) }}
          </mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field
        appearance="outline"
        class="theme-select"
        *ngIf="selectedWarehouseId"
      >
        <mat-label>File Type</mat-label>

        <mat-select
          [(ngModel)]="fileType"
          name="fileType"
          (selectionChange)="selectedFile = null; selectedFiles = []"
        >
          <mat-option value="report">Report</mat-option>
          <mat-option value="claims">Claims</mat-option>
        </mat-select>
      </mat-form-field>

    </div>


    <div
      class="file-upload-container"
      [class.disabled]="isLoading || !fileType"
    >

      <input
        type="file"
        id="fileInput"
        (change)="onFileSelected($event)"
        [multiple]="isCargoVanSelected && fileType === 'report'"
        [accept]="
          fileType === 'claims'
            ? '.xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            : isCargoVanSelected
              ? '.pdf,application/pdf'
              : '.xml,.xls,.xlsx,application/xml,text/xml,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        "
        hidden
      />

      <label
        for="fileInput"
        class="file-label"
        [ngClass]="{
          disabled: isLoading || !fileType
        }"
      >

        <div class="upload-icon-circle">
          <mat-icon>cloud_upload</mat-icon>
        </div>

        <div class="upload-text">

          <strong *ngIf="!selectedFile && selectedFiles.length === 0">
            {{
              isCargoVanSelected && fileType === 'report'
                ? 'Select PDF Files'
                : 'Select File'
            }}
          </strong>

          <strong *ngIf="selectedFile && selectedFiles.length <= 1">
            {{ selectedFile.name }}
          </strong>

          <strong *ngIf="selectedFiles.length > 1">
            {{ selectedFiles.length }} files selected
          </strong>

          <span *ngIf="!selectedFile && selectedFiles.length === 0">
            Click here to browse your files
          </span>

          <span *ngIf="selectedFile || selectedFiles.length > 0">
            Click to choose a different file
          </span>

        </div>

      </label>

    </div>


    <div
      class="selected-file-info"
      *ngIf="selectedFile || selectedFiles.length > 0"
    >
      <mat-icon>description</mat-icon>

      <div class="selected-file-info__content">
        <span>Ready to upload</span>

        <strong *ngIf="selectedFiles.length <= 1">
          {{ selectedFile?.name }}
        </strong>

        <strong *ngIf="selectedFiles.length > 1">
          {{ selectedFiles.length }} files selected
        </strong>
      </div>
    </div>

  </div>


  <mat-divider></mat-divider>


  <div class="upload-actions">

    <button
      mat-button
      mat-dialog-close
      type="button"
      class="cancel-btn"
      [disabled]="isLoading"
    >
      Cancel
    </button>

    <button
  mat-flat-button
  color="primary"
  type="button"
  class="upload-btn"
  (click)="uploadFile($event)"
  [disabled]="
    isLoading ||
    !selectedWarehouseId ||
    !fileType ||
    (
      isCargoVanSelected && fileType === 'report'
        ? selectedFiles.length === 0
        : !selectedFile
    )
  "
>
  <mat-progress-spinner
    *ngIf="isLoading"
    mode="indeterminate"
    diameter="18"
  ></mat-progress-spinner>

  <mat-icon *ngIf="!isLoading">
    upload
  </mat-icon>

  <span *ngIf="!isLoading">
    {{
      isCargoVanSelected && fileType === 'report'
        ? 'Upload Files'
        : 'Upload File'
    }}
  </span>
</button>

  </div>

</div>